import React from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import Preloader from '../../Preloader/Preloader';
import UserList from '../UserList/UserList';
import AssignReportsForm from '../AssignReportsForm/AttachReportsForm';
import AssignReportsWrapper from './AssignReports.style';
import { getUserList, setConversationUser, getTemplateList, setTemplateId, getTemplateReports, searchReportTitles, setReportSearchResult, setScratchReports, assignReports, setTemplateReports, setSelectedTemplateReports } from '../../../redux/actions/Box/BoxActions';

class AssignReports extends React.Component {
  
  constructor() {
    super();
    this.setUser = this.setUser.bind(this);
    this.handleTemplateSelect = this.handleTemplateSelect.bind(this);
    this.handleSetScratchReports = this.handleSetScratchReports.bind(this);
    this.handleRemoveScratchReports = this.handleRemoveScratchReports.bind(this);
    this.handleAssignReports = this.handleAssignReports.bind(this);
    this.handleTemplateReports = this.handleTemplateReports.bind(this);
  }

  componentDidMount() {
    this.props.getUserList(this.props.from);
    this.props.getTemplateList();
    this.props.setConversationUser({ id: 0 });
    this.props.setReportSearchResult([]);
    this.props.setTemplateReports([]);
    this.props.setSelectedTemplateReports([]);
    this.props.setScratchReports([]);
  }

  setUser(user) {
    this.props.setConversationUser(user);
  }

  handleTemplateSelect(value) {
    this.props.setTemplateId(value);
    this.props.getTemplateReports(value);
  }
  
  handleTemplateReports(value) {
    this.props.setSelectedTemplateReports(value);
  }

  handleSetScratchReports(value) {
    let scratch_reports = this.props.BOXREDUCER.scratch_reports;
    if(!scratch_reports.includes(value)) {
      scratch_reports.push(value);
      this.props.setScratchReports(scratch_reports);
    }
    else {
      message.error('Report already exists in list!');
    }
  }

  handleRemoveScratchReports(i) {
    let scratch_reports = this.props.BOXREDUCER.scratch_reports;
    scratch_reports.splice(i,1);
    this.props.setScratchReports(scratch_reports);
  }

  handleAssignReports() {
    const user_id = this.props.BOXREDUCER.conversation_user.id;
    let template_reports = [];
    if(this.props.BOXREDUCER.selected_template_reports.length > 0) {
      template_reports = this.props.BOXREDUCER.selected_template_reports;
    }
    let scratch_reports = [];
    if(this.props.BOXREDUCER.scratch_reports.length > 0) {
      scratch_reports = this.props.BOXREDUCER.scratch_reports.map(report => parseInt(report.split(":")[1]));
    }
    let report_id = template_reports.concat(scratch_reports);
    this.props.assignReports(user_id,report_id);
  }
  
  render() {
    if(this.props.APPREDUCER.showPreloader === true) {
      return(
        <Preloader />
      )
    }
    else {
      let assign_reports_view;
      if(this.props.BOXREDUCER.conversation_user.id === 0) {
        const box_user_list = this.props.BOXREDUCER.user_list;
        assign_reports_view = <UserList
                                data={box_user_list}
                                from={this.props.from}
                                getUserReports={null}
                                setUser={this.setUser}
                              />;
      }
      else {
        assign_reports_view = <AssignReportsForm
                                templateList={this.props.BOXREDUCER.template_list}
                                setTemplateId={this.handleTemplateSelect}
                                templateReportList={this.props.BOXREDUCER.template_reports}
                                selectedTemplateReports={this.props.BOXREDUCER.selected_template_reports}
                                handleTemplateReports={this.handleTemplateReports}
                                searchReportTitles={this.props.searchReportTitles}
                                searchReportResults={this.props.BOXREDUCER.search_reports_result}
                                setScratchReports={this.handleSetScratchReports}
                                scratchReports={this.props.BOXREDUCER.scratch_reports}
                                removeScratchReports={this.handleRemoveScratchReports}
                                handleAssignReports={this.handleAssignReports}
                                isReportAssigning={this.props.BOXREDUCER.is_report_assigning}
                                setConversationUser={this.props.setConversationUser}
                              />
      }
      
      return(
        <AssignReportsWrapper>
          {assign_reports_view}
        </AssignReportsWrapper>
      )
  
    }
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  getUserList,
  setConversationUser,
  getTemplateList,
  setTemplateId,
  getTemplateReports,
  searchReportTitles,
  setReportSearchResult,
  setScratchReports,
  assignReports,
  setTemplateReports,
  setSelectedTemplateReports
};

export default connect(mapStateToProps,mapDispatchToProps)(AssignReports);


// WEBPACK FOOTER //
// ./src/components/Box/AssignReports/AssignReports.js